module.exports = "/_next/static/images/carriers-bg-hero-6bd85b4820a93cf1d66f5f414106dd7f.png.webp";